import {Component} from "react";
import { injectStripe } from 'react-stripe-elements';

class AuthenticateStripePayment extends Component {

  componentDidMount() {
    this.retrievePaymentIntent(this.props.clientSecret);
  }

  retrievePaymentIntent(clientSecret) {
    const self = this;
    this.props.stripe.retrievePaymentIntent(
      clientSecret
    ).then(function(result) {
      if (result.error) {
        self.props.onError("Payment information for this order could not be found or not retrieved at this moment in time.")
      } else {
        self.confirmPayment(clientSecret, result.paymentIntent);
      }
    })
  }


  confirmPayment(clientSecret, intent) {
    // Pass the failed PaymentIntent to your client from your server
    const self = this;
    this.props.stripe.confirmCardPayment(clientSecret, {
      payment_method: intent.last_payment_error.payment_method.id
    }).then(function(result) {
      if (result.error) {
        // Show error to your customer
        self.props.onError(result.error.message);
      } else {
        if (result.paymentIntent.status === 'succeeded') {
          // The payment is complete!
          self.props.onSuccess();
        }
      }
    });    
  }

  render() {
    return null;
  }

}

export default injectStripe(AuthenticateStripePayment);